import ApplicationController from "./application_controller"

export default class extends ApplicationController {
  connect () {
    super.connect()

    this.setupSentinel()
    this.startObserving()
  }

  disconnect () {
    this.stopObserving()
    this.removeSentinel()

    super.disconnect()
  }

  setupSentinel () {
    // We create a "sentinel" element that we insert either above or below the element we want to observe.
    // We then use IntersectionObserver to watch this sentinel, which provides more accurate "stuck"
    // detection that works reliably on iOS.
    //
    // See: https://www.npmjs.com/package/@evanminto/sticky-sentinel-element
    this.sentinel = document.createElement("div")

    Object.assign(this.sentinel.style, {
      width: "100%",
      height: "1px",
      visibility: "hidden",
      pointerEvents: "none",
      position: "relative",
      zIndex: -1
    })

    const parent = this.element.parentNode

    if (this.sentinelPlacement === "top") {
      parent.insertBefore(this.sentinel, this.element)
    } else {
      parent.insertBefore(this.sentinel, this.element.nextSibling)
    }
  }

  removeSentinel () {
    this.sentinel.remove()
  }

  startObserving () {
    this.observer = new IntersectionObserver(this.didIntersect, {
      threshold: [0, 1],
      rootMargin: "0px",
    })
    this.observer.observe(this.sentinel)
  }

  stopObserving () {
    this.observer.disconnect()
  }

  didIntersect = ([entry]) => {
    this.element.classList.toggle("stuck", entry.intersectionRatio < 1)
  }

  get sentinelPlacement () {
    const style = window.getComputedStyle(this.element)
    const hasTopValue = style.top !== "auto" && style.top !== ""
    const hasBottomValue = style.bottom !== "auto" && style.bottom !== ""

    return (hasTopValue && !hasBottomValue) ? "top" : "bottom"
  }
}
